//import createjs from 'preload-js'
import router from '@/router'
import store from '@/store'
import { gsap, Power3 } from 'gsap/all'
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
gsap.registerPlugin(ScrollToPlugin)
const gh = {
    haptic: new Audio('/assets/haptic.mp3'),
    haptic2: new Audio('/assets/haptic2.mp3'),
    gy: new Audio('/assets/gy.mp3'),
    globalSectionInit: function() {
        /*
        setTimeout(function() {
            //gh.aosInit()
        },500)

         */
    },
    playHaptic() {
        gh.haptic.play()
    },
    playHaptic2() {
        gh.haptic2.play()
    },
    playGoldenYears() {
        gh.gy.play()
    },
    scrollTo(route) {
        const tid = '#section-' + route
        gsap.to(window, {
            duration: 0.5,
            scrollTo: tid,
            ease: Power3.easeInOut
        })
    },
    scrollToTop() {
        gsap.to(window, {
            duration: 0.5,
            scrollTo: 0,
            ease: Power3.easeInOut
        })
    },
    isScrolledIntoView(el) {
        let rect = el.getBoundingClientRect()
        let elemTop = rect.top
        let elemBottom = rect.bottom
        let wh = window.innerHeight

        // Only completely visible elements return true:
        //let isVisible = (elemTop >= 0) && (elemBottom <= wh)
        // Partially visible elements return true
        //let isVisible = elemTop < wh && elemBottom >= 0
        // visible counts at 33% from top
        let pageAdjuster = wh/3

        let isVisible = ((elemTop - pageAdjuster) < wh) && (elemBottom - pageAdjuster >= 0)
        return isVisible
    },
    enableBodyScroll(enable) {
        if (enable) {
            document.body.classList.remove("no-scroll")
            window.scrollTo(0, gh.bodyScrollY)
            document.body.style.top = 0
        } else {
            gh.bodyScrollY = window.scrollY
            document.body.classList.add("no-scroll")
            document.body.style.top = -gh.bodyScrollY+'px'
        }
    },
    stripSlashesFrontAndBack(val) {
        if (val) {
            val = val.toString()
            if(val.substr(-1) === '/') {
                val = val.substr(0, val.length - 1);
            }
            if(val.substr(0,1) === '/') {
                val = val.substr(1, val.length);
            }
        }
        return val
    },

    getRouteObjectFromVal(val, grabFromPath = false) {
        let ret = null
        let comparator = (grabFromPath) ? 'path' : 'hook'
        for (let i = 0;i < window.config.json.global.routes.length;i++) {
            let obj = window.config.json.global.routes[i]
            if (obj[comparator] === val) {
                ret = obj
            }
        }
        return ret
    },
    pingAnalyticsCustom(section, val, eventLabel=null,eventValue=null ) {
        let obj = {
            'event_category' : val,
            'event_label': eventLabel,
            'value': eventValue
        }
        //console.log('gtag', obj)
        window.gtag('event', section, obj)
    },
    pingAnalyticsChangeRoute(val) {
        if (val) {
            try {
                let eventLabel = null
                let eventValue = null
                if (store.state.currentSubsection?.includes('library')) {
                    eventLabel = String(store.state.currentLibrarySubsection)
                    eventValue = String(store.state.currentLibraryNamesContent)
                }
                gh.pingAnalyticsCustom('section', val, eventLabel, eventValue)
                let obj = gh.getRouteObjectFromVal(val)
                if (obj) {
                    router.push(obj)
                }

            } catch (e) {
                console.log('gtag', e, val)
            }
        }
    },
    openOverlay(type) {
        console.log('store', store, type)
        store.commit('setOverlay',{
            type: type
        })
    },
    closeOverlay() {
        store.commit('setOverlay',null)
    }
}
export default gh
